import React from "react";
import { ProfileVerificationsRow } from "./ProfileVerificationsRow";

export const ProfileVerificationsTable = ({
  requests,
  loading,
  approvalLoading,
  onApprove,
  onReject,
  onViewProfile,
  onLoadMore,
  pagination
}) => (
  <div className="rounded-3xl bg-jp-card border border-jp-line overflow-hidden">
    {/* Scrollable Table Container */}
    <div className="overflow-auto" style={{ maxHeight: '500px' }}>
      <table className="min-w-full text-[11px] border-collapse">
        <thead className="bg-jp-card text-jp-ink sticky top-0 z-10">
          <tr className="border-b border-jp-line">
            <th className="px-4 py-3 text-center bg-jp-card border-b border-jp-line">NAME</th>
            <th className="px-4 py-3 text-center bg-jp-card border-b border-jp-line">EMAIL</th>
            <th className="px-4 py-3 text-center bg-jp-card border-b border-jp-line">ROLE</th>
            <th className="px-4 py-3 text-center bg-jp-card border-b border-jp-line">DOCUMENT</th>
            <th className="px-4 py-3 text-center bg-jp-card border-b border-jp-line">SUBMITTED AT</th>
            <th className="px-4 py-3 text-center bg-jp-card border-b border-jp-line">STATUS</th>
            <th className="px-4 py-3 text-center bg-jp-card border-b border-jp-line">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          {loading && requests.length === 0 ? (
            <tr>
              <td colSpan="7" className="px-4 py-8 text-center text-jp-muted">
                Loading...
              </td>
            </tr>
          ) : requests.length === 0 ? (
            <tr>
              <td colSpan="7" className="px-4 py-8 text-center text-jp-muted">
                No pending approvals found
              </td>
            </tr>
          ) : (
            <>
              {requests.map((approval) => (
                <ProfileVerificationsRow
                  key={approval._id}
                  approval={approval}
                  onApprove={onApprove}
                  onReject={onReject}
                  onViewProfile={onViewProfile}
                  loading={approvalLoading[approval._id]}
                />
              ))}
              {/* Load More Row */}
              {pagination?.hasMore && (
                <tr>
                  <td colSpan="7" className="px-4 py-4 text-center">
                    <button
                      onClick={onLoadMore}
                      disabled={loading}
                      className="px-6 py-2 rounded-lg bg-sky-500 text-white text-xs font-semibold hover:bg-sky-400 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                      {loading ? "Loading..." : "Load More"}
                    </button>
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </div>

    {/* Fixed Footer - Showing results info */}
    {pagination && requests.length > 0 && (
      <div className="px-6 py-3 border-t border-jp-line bg-jp-card">
        <div className="text-xs text-jp-muted text-center">
          Showing {requests.length} of {pagination.totalCount} results
        </div>
      </div>
    )}
  </div>
);
